import { __assign, __rest } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import { Box } from '../layout/Box.js';
import { Stack } from '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import '../media/Img.js';
import { Icon } from '../media/Icon.js';
import '../typography/Text.js';
import '../typography/Display.js';
import { Heading } from '../typography/Heading.js';
import '../typography/Label.js';
import '../typography/Paragraph.js';
import React__default from 'react';
import styled from 'styled-components';
import '../../node_modules/styled-system/dist/index.esm.js';
import { colorSchemes } from '../../theme/colors.js';
import { variant } from '../../node_modules/@styled-system/variant/dist/index.esm.js';
import { color } from '../../node_modules/@styled-system/color/dist/index.esm.js';
var TagContainer = styled(Box)(function (_a) {
  var withDot = _a.withDot;
  return css({
    paddingLeft: withDot ? "2px" : "6px",
    paddingRight: "6px",
    display: "inline-flex",
    alignItems: "center"
  });
}, variant({
  prop: "size",
  variants: {
    md: {
      height: "16px",
      borderRadius: "4px"
    },
    lg: {
      height: "24px",
      borderRadius: "8px"
    }
  }
}), variant({
  prop: "colorScheme",
  variants: __assign(__assign({}, colorSchemes.reduce(function (accumulator, colorScheme) {
    var _a;
    return __assign(__assign({}, accumulator), (_a = {}, _a[colorScheme] = {
      backgroundColor: "label.".concat(colorScheme)
    }, _a));
  }, {})), {
    default: {
      backgroundColor: "grey.4"
    }
  })
}), color);
var Tag = React__default.forwardRef(function (_a, ref) {
  var withDot = _a.withDot,
    _b = _a.colorScheme,
    colorScheme = _b === void 0 ? "default" : _b,
    _c = _a.size,
    size = _c === void 0 ? "md" : _c,
    children = _a.children,
    rest = __rest(_a, ["withDot", "colorScheme", "size", "children"]);
  return React__default.createElement(TagContainer, __assign({}, rest, {
    ref: ref,
    size: size,
    colorScheme: colorScheme
  }), React__default.createElement(Stack, {
    spacing: "2px",
    align: "center",
    color: "inherit"
  }, withDot && React__default.createElement(Icon, {
    fontSize: "16px",
    icon: "dot",
    color: "".concat(colorScheme, ".300")
  }), React__default.createElement(Heading, {
    size: "xxs",
    fontSize: size === "md" ? "10px" : undefined,
    lineHeight: size === "md" ? "10px" : undefined,
    color: "inherit"
  }, children)));
});
export { Tag };